export default __webpack_public_path__ + "static/media/three-dots.a7387a01.svg";